export default "__VITE_ASSET__D1P_RDPM__"